import LogoIcon from '../../assets/icons/LogoIcon.tsx';

interface LogoProps {
  className?: string;
}

const Logo = ({ ...rest }: LogoProps) => {
  return <LogoIcon sx={{ width: 'auto', height: { xs: 18, md: 25 } }} {...rest} />;
};

export default Logo;
